/**
 * "AI & Your Future" content for the /ai-and-you section.
 *
 * Data lives in aiFuture.data.json — synthesised by the expert-research
 * workflow from public Anthropic / Claude interviews, essays and research
 * (Economic Index, education reports, "Machines of Loving Grace", Claude for
 * Financial Services) and written in our own words (no quotations). Pure
 * information, no quizzes. Two tracks the page toggles between: studies & careers.
 */
import data from './aiFuture.data.json';

export interface AiTheme {
  heading: string;
  body: string;
}

export interface AiTrack {
  intro: string;
  themes: AiTheme[];
  tips: string[];
  /** Plain-language note on the kinds of sources behind this track. */
  sourcesNote: string;
}

export const aiStudies: AiTrack = data.studies as AiTrack;
export const aiCareers: AiTrack = data.careers as AiTrack;
